import React, { useContext } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import { isEmpty, startCase } from 'lodash'
import helper from '../../utils/helpers'
import { AiFillEdit, AiFillEye } from 'react-icons/ai'
import { Link, NavLink } from 'react-router-dom'
import dayjs from 'dayjs'
import Timer from 'components/reusable/Timer'
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)

const AuctionTable = ({ auctions, AllAuctions, paginationObj, manager }) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()

  const getAuctionData = (auctionStartDate, auctionEndDate) => {
    const auctionStartDateTime = dayjs(auctionStartDate)
    const auctionEndDateTime = dayjs(auctionEndDate)
    const currentDate = dayjs()
    if (
      dayjs(currentDate).isBetween(auctionStartDateTime, auctionEndDateTime)
    ) {
      return 'Active'
    } else if (dayjs(currentDate).isSameOrBefore(auctionStartDateTime)) {
      return 'Upcoming'
    } else if (dayjs(currentDate).isSameOrAfter(auctionEndDateTime)) {
      return 'Expired'
    }
  }
  const endAuction = async item => {
    try {
      const payload = {
        status: 'ended'
      }
      const path = `${apiPath.endAuction}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        AllAuctions()
      }
      // }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }
  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.ChangeStatusProperties}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.data?.success) {
        notification.success(result.data.message)
        AllAuctions()
      } else {
        notification.error(result.data.message)
      }
      // }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }

  const handleOnComplete = () => {
    AllAuctions()
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6 text-center'>
                #
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_PROPERTY_ID')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_PROPERTY_TITLE')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_AUCTION_START_DATE')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_AUCTION_END_DATE')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_NO_OF_BIDS')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('AUCTION_TIMER')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_AUCTION_STATUS')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_CREATED_AT')}
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <th scope='col' className='py-3 px-6'>
                  {t('O_STATUS')}
                </th>
              )}
              <th scope='col' className='py-3 px-6 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {auctions &&
              auctions?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.propertyId}</td>
                  <td className='py-2 px-2 border-r'>
                    {startCase(item?.title)}
                  </td>
                  <td className='py-2 px-2 border-r'>
                    {helper.dateFormat(item?.auctionStartDateTime)}
                  </td>
                  <td className='py-2 px-2 border-r'>
                    {helper.dateFormat(item?.auctionEndDateTime)}
                  </td>
                  <td className='py-2 px-2 border-r'>{item?.totalBids}</td>
                  <td className='py-2 px-2 border-r'>
                    {getAuctionData(
                      item?.auctionStartDateTime,
                      item?.auctionEndDateTime
                    ) === 'Active' && item?.auctionStatus !== 'ended' && item?.isApprovedStatus != 'draft' ? (
                      <Timer
                        futureDate={item?.auctionEndDateTime}
                        onComplete={handleOnComplete}
                      />
                    ) : (
                      ''
                    )}
                  </td>
                  <td className='py-2 px-2 border-r text-center'>
										{item.isApprovedStatus ==='draft' ?  <span>{startCase(item.isApprovedStatus)}</span>:
										item?.auctionStatus === 'ended' ? (
											<NavLink to='/auction/status' state={{ status: 'Ended', item }} className=' hover:bg-white text-red-500'>
												Ended
											</NavLink>
										) : getAuctionData(item?.auctionStartDateTime, item?.auctionEndDateTime) === 'Active' ? (
											<NavLink to='/auction/status' state={{ status: 'Active', item }} className=' hover:bg-whit text-green-500'>
												Active
											</NavLink>
										) : getAuctionData(item?.auctionStartDateTime, item?.auctionEndDateTime) === 'Expired' ? (
											<NavLink to='/auction/status' state={{ status: 'Expired', item }} className=' hover:bg-white text-red-800'>
												Expired
											</NavLink>
										) : (

											<span> {getAuctionData(item?.auctionStartDateTime, item?.auctionEndDateTime)}</span>
										)}
									</td>

                  <td className='py-2 px-2 border-r'>
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        // title={t('O_STATUS')}
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          // value={status}
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? 'active' : 'inactive'
                              } ${item.title}?`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  <td className='py-2 px-2 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        {(manager?.add || user?.role === 'admin') && (
                          <li className='px-2 py-2 hover:bg-white hover:text-LightBlue'>
                            {getAuctionData(
                              item?.auctionStartDateTime,
                              item?.auctionEndDateTime
                            ) === 'Active' &&
                              item?.auctionStatus === 'active' && item?.isApprovedStatus != 'draft' && (
                                <button
                                  onClick={() =>
                                    helper.alertFunction(
                                      `Are you sure want to end auction ${item.title}?`,
                                      item,
                                      endAuction
                                    )
                                  }
                                  className='text-red-600'
                                >
                                  {t('END_AUCTION')}
                                </button>
                              )}
                          </li>
                        )}
                        <li className='px-2 py-2 hover:bg-white hover:text-LightBlue'>
                          <NavLink
                            to={`/auction/view/${item._id}`}
                            state={{ item, propertyId: item?._id }}
                          >
                            <AiFillEye className='cursor-pointer w-5 h-5 text-slate-600' />
                          </NavLink>
                        </li>
                        {(manager?.add || user?.role === 'admin') && (
                          <li className='px-2 py-2 hover:bg-white hover:text-LightBlue'>
                            <Link
                              title={t('O_EDIT_PROPERTY')}
                              to={'/auction/edit-property/' + item._id}
                            >
                              <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(auctions) && (
              <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-2 px-2' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AuctionTable
